<template>
  <div>
    <template v-if="isWide">
      <RainWideLayer :boundsList="boundsList" />
    </template>
    <template v-else>
      <LImageOverlay
        v-for="(layer, key) in tileLayers"
        :key="key"
        :url="layer.url"
        :bounds="layer.bounds"
        :opacity="opacity"
      />
    </template>
  </div>
</template>
<script>
import { LImageOverlay } from "vue2-leaflet";
import * as api from "../../../utils/api";
import moment from "moment";
import L from "leaflet";
import RainWideLayer from "./RainWideLayer";

export default {
  name: "KouzuiKikikuruLayer",
  components: {
    LImageOverlay,
    RainWideLayer
  },
  data() {
    return {
      tiles: [],
      tileImages: [],
      boundsList: [],
      currentTileBounds: null,
      currentBaseDate: null
    };
  },
  computed: {
    map() {
      return this.$store.getters.leafletMap;
    },
    opacity() {
      return this.$store.getters.riskSubControl.opacity;
    },
    selectedDate() {
      return this.$store.getters.selectedDate;
    },
    baseDate() {
      const baseDate = this.$store.getters.baseDate.clone();
      baseDate.subtract(baseDate.minute() % 5, "minutes");
      return baseDate.utc().format("YYYY/MM/DD HH:mm");
    },
    timeSeries() {
      return this.$store.getters.rainImageInfo;
    },
    selectedRain() {
      const d = this.selectedDate.clone().utc();
      const date = d.format("YYYY/MM/DD HH:mm");
      return this.timeSeries.find(r => r.date === date);
    },
    tileUrl() {
      if (this.isWide === true) {
        return "";
      }
      return this.selectedRain ? this.selectedRain.tileUrl : "";
    },
    zoom() {
      return Math.floor(this.map.getZoom());
    },
    isWide() {
      return this.zoom <= 9;
    },
    tileLayers() {
      if (!this.tileUrl || this.zoom <= 9) {
        return [];
      }
      return this.tiles.map(tile => {
        return {
          bounds: tile.bounds,
          url: this.tileUrl.replace("{code}", tile.code)
        };
      });
    }
  },
  watch: {
    baseDate(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentBaseDate = null;
        this.sync();
      }
    }
  },
  async created() {
    await this.sync();
    this.map.on("moveend", this.mapMoveend);
  },
  beforeDestroy() {
    this.map.off("moveend", this.mapMoveend);
  },
  methods: {
    async mapMoveend() {
      if (this.currentTileBounds !== null) {
        const contained = this.currentTileBounds.contains(this.map.getBounds());
        if (contained === true) {
          return;
        }
      }
      if (this.zoom > 9) {
        this.sync();
      }
    },
    async sync() {
      const northwest = this.map.getBounds().getNorthWest();
      const southeast = this.map.getBounds().getSouthEast();

      const params = {
        northwest_lat: northwest.lat,
        northwest_lng: northwest.lng,
        southeast_lat: southeast.lat,
        southeast_lng: southeast.lng,
        date: this.baseDate
      };
      const response = await api.get("/inundation-kikikuru/flood", params);
      if (response === null) {
        this.$store.commit("SET_RAIN_IMAGE_INFO", []);
        return;
      }
      this.boundsList = response.bounds;
      if (this.isWide === false) {
        this.tiles = response.tiles;
      } else {
        this.tiles = [];
      }
      this.loadCurrentTileBounds(northwest, southeast);

      // download tile urls
      const urls = [];
      response.timeSeries.forEach(r => {
        this.tiles.forEach(tile => {
          if (r.tileUrl) {
            urls.push(r.tileUrl.replace("{code}", tile.code));
          }
        });
      });
      this.tileImages = urls.map(url => {
        const image = new Image();
        image.src = url;
        return image;
      });

      // download wide urls
      const rainImageInfo = response.timeSeries.map(r => {
        const image = new Image();
        image.src = r.url;
        r.image = image;
        return r;
      });
      const responseBaseDate = moment.utc(
        response.baseDate,
        "YYYY/MM/DD HH:mm"
      );
      this.$store.commit("SET_RISK_BASE_DATE", responseBaseDate.clone());
      if (this.currentBaseDate === null) {
        this.currentBaseDate = responseBaseDate;
        this.$store.commit("SET_SELECTED_DATE", responseBaseDate.clone());
      }
      this.$store.commit("SET_RAIN_IMAGE_INFO", rainImageInfo);
    },
    loadCurrentTileBounds(queryNorthwest, querySoutheast) {
      if (this.tiles.length === 0) {
        this.currentTileBounds = null;
        return;
      }
      const northwestLat = this.tiles.map(t => t.bounds[0][0]);
      const northwestLng = this.tiles.map(t => t.bounds[0][1]);
      const southeastLat = this.tiles.map(t => t.bounds[1][0]);
      const southeastLng = this.tiles.map(t => t.bounds[1][1]);
      northwestLat.push(queryNorthwest.lat);
      northwestLng.push(queryNorthwest.lng);
      southeastLat.push(querySoutheast.lat);
      southeastLng.push(querySoutheast.lng);

      const northwest = L.latLng([
        Math.max(...northwestLat),
        Math.min(...northwestLng)
      ]);
      const southeast = L.latLng([
        Math.min(...southeastLat),
        Math.max(...southeastLng)
      ]);
      this.currentTileBounds = L.latLngBounds(northwest, southeast);
    }
  }
};
</script>
